import actions from './actions';
import * as selectors from './selectors';

export default {
  actions,
  selectors,
};
